import { api } from "../App";
import {itemsOnPage, recipientActionTypes} from "../assets/const";
import {createNotification} from "../components/Notifications/Notifications";
import {
    SET_FAQ,
    SET_FAQ_LOADING,
    SET_FAQ_BY_ID,
    SET_FAQ_BY_ID_LOADING,
    SET_FIO,
    SET_MESSAGE,
    SET_MESSAGE_LOADING,
    SET_FAQ_PAGE,
    SET_FAQ_COUNT
} from "./types";

export const setPage = (pageNumber) => ({type: SET_FAQ_PAGE, payload: pageNumber })

export const getFAQ = (params) => async(dispatch, getState) => {
    const { pageNumber } = getState().FAQ
    const max_results = itemsOnPage
    const paginate_from = itemsOnPage * pageNumber
    let copyParams = {
        ...params,
        to_date: `${params.to_date}  23:59:59`,
        max_results: max_results,
        paginate_from: paginate_from
    }

    // type_id=0 означает "Все" — API принимает только 1/2/3, иначе 422
    if (!copyParams.type_id) delete copyParams.type_id
    // mid=0 означает "Все" — не передаём
    if (!copyParams.mid) delete copyParams.mid
    // pageNumber не является параметром API
    delete copyParams.pageNumber

    const urlParams = new URLSearchParams(copyParams).toString();

    dispatch({type: SET_FAQ_LOADING, payload: true});

    try {
        const { data } = await api.get(`/faq?${urlParams}`);
        const {count, dialogues} = data;
        const pageCount = Math.ceil(count / itemsOnPage)

        dispatch({type: SET_FAQ, payload: dialogues});
        dispatch({ type: SET_FAQ_COUNT, payload: {pageCount, count} });
    } catch (error) {
        console.error('Error in FAQ action:', error);
        createNotification('error', 'Ошибка');
    } finally {
        dispatch({type: SET_FAQ_LOADING, payload: false});
    }
};

export const getFioList = () => async(dispatch, getState) => {
    try {
        const { data } = await api.get(`/faq/interlocutors`);
        dispatch({type: SET_FIO, payload: data});
    } catch (error) {
        console.error('Error in FAQ action:', error);
    }
};

export const getFAQById = (id) => async(dispatch, getState) => {
    try {
        dispatch({type: SET_FAQ_BY_ID_LOADING, payload: true});
        const { data } = await api.get(`/posts/${id}`);
        dispatch({type: SET_FAQ_BY_ID, payload: data});
    } catch (error) {
        console.error('Error in FAQ action:', error);
    } finally {
        dispatch({type: SET_FAQ_BY_ID_LOADING, payload: false});
    }
};

export const createFAQ = (data, params, files) => async(dispatch, getState) => {
    try {
        const { data: result } = await api.post(`/faq`, data);
        const created = result.created || [];
        if (files && files.length) {
            for (const item of created) {
                dispatch(addFiles(item.dialogue_id, item.message_id, files))
            }
        }
        createNotification('success', 'Успешно');
    } catch (error) {
        console.error('Error in FAQ action:', error);
        createNotification('error', 'Ошибка');
    } finally {
        await dispatch(getFAQ(params));
    }
};

export const editFAQ = (data, params, id) => async(dispatch, getState) => {
    try {
        await api.put(`/faq/${id}`, data);
        createNotification('success', 'Успешно');
    } catch (error) {
        console.error('Error in FAQ action:', error);
        createNotification('error', 'Ошибка');
    } finally {
        await dispatch(getFAQ(params));
    }
};

export const deleteFAQ = (id, params) => async(dispatch, getState) => {
    try {
        await api.delete(`/faq/${id}`);
        createNotification('success', 'Успешно');
    } catch (error) {
        console.error('Error in FAQ action:', error);
        createNotification('error', 'Ошибка');
    } finally {
        await dispatch(getFAQ(params));
    }
};

export const getRecipient = (recipientType) => async(dispatch, getState) => {
    dispatch({type: SET_MESSAGE_LOADING, payload: true});

    try {
        const path = (recipientActionTypes[recipientType]).toLowerCase();
        const { data } = await api.get(`/faq/recipient/${path}`);
        dispatch({type: `SET_${[recipientActionTypes[recipientType]]}`, payload: data});
    } catch (error) {
        console.error('Error in FAQ action:', error);
        createNotification('error', 'Ошибка');
    } finally {
        dispatch({type: SET_MESSAGE_LOADING, payload: false});
    }
};

/// MESSAGE ACTION

export const getMessage = (id) => async (dispatch, getState) => {
    dispatch({type: SET_MESSAGE_LOADING, payload: true});

    try {
        const { data } = await api.get(`/faq/${id}`);
        dispatch({type: SET_MESSAGE, payload: {id, data}});
    } catch (error) {
        console.error('Error in FAQ action:', error);
        createNotification('error', 'Ошибка');
    } finally {
        dispatch({type: SET_MESSAGE_LOADING, payload: false});
    }
};

export const createMessage = (data, files) => async(dispatch, getState) => {
    try {
        const { data: newdata } = await api.post(`/faq/${data.chat}/messages`, {parent: data.parent, message: data.message});
        if (files && files.length) {
            await dispatch(addFiles(data.chat, newdata.id, files))
        }
        createNotification('success', 'Успешно');
    } catch (error) {
        console.error('Error in FAQ action:', error);
        createNotification('error', 'Ошибка');
    } finally {
        await dispatch(getMessage(data.chat));
    }
};

export const editMessage = (data, chatID, id, files, filesDelete) => async(dispatch, getState) => {
    try {
        await api.put(`/faq/${chatID}/messages/${id}`, data);
        if (files && files.length) {
            dispatch(addFiles(chatID, id, files))
        }
        if (filesDelete?.length) {
            filesDelete.map(element =>
                dispatch(deleteFile(chatID, id, element.file_name))
            )
        }
        createNotification('success', 'Успешно');
    } catch (error) {
        console.error('Error in FAQ action:', error);
        createNotification('error', 'Ошибка');
    } finally {
        await dispatch(getMessage(chatID));
    }
};

export const deleteMessage = (id, chat) => async(dispatch, getState) => {
    try {
        await api.delete(`/faq/${chat}/messages/${id}`);
        createNotification('success', 'Успешно');
    } catch (error) {
        console.error('Error in FAQ action:', error);
        createNotification('error', 'Ошибка');
    } finally {
        await dispatch(getMessage(chat));
    }
};

/// MESSAGE ACTION


/// FILES

export const addFiles = (chatID, messageID, data) => async (dispatch, getState) => {
    try {
        const fd = new FormData();
        for (let file of data) { fd.append('files', file); }
        await api.post(`/faq/${chatID}/messages/${messageID}/files`, fd);
    } catch (error) {
        console.error('Error in FAQ action:', error);
    }
};

export const deleteFile = (chatID, messageID, fileName) => async(dispatch, getState) => {
    try {
        await api.delete(`/faq/${chatID}/messages/${messageID}/files/${fileName}`);
        createNotification('success', 'Успешно удалено');
    } catch (error) {
        console.error('Error in FAQ action:', error);
        createNotification('error', 'Ошибка удаления');
    }
};

export const deleteFiles = deleteFile;
export const getFiles = () => async() => {};

/// FILES
